import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetBudgetForYearResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                year: "2026",
                sales_forecast_file: {
                    name: "sales_forecast_2026.xlsx",
                    url: "https://example.com/files/sales_forecast_2026.xlsx",
                },
                inflation_forecast_file: {
                    name: "inflation_forecast_2026.xlsx",
                    url: "https://example.com/files/inflation_forecast_2026.xlsx",
                },
            },
            errors: []
        }
    }

    budget() {
        const budgetResponse = this.content();
        return {
            year: budgetResponse.year,
            salesForecastFile: budgetResponse.sales_forecast_file,
            inflationForecastFile: budgetResponse.inflation_forecast_file,
        };
    }
}
